import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BluetoothPrinterService } from 'src/app/services/bluetooth-api/bluetooh-printer.service';
import { ImpresionComponent } from '../impresion.component';
import { Cobro } from 'src/app/models/cobranza/cobro.model';

@Component({
  selector: 'app-impresion-cobro',
  templateUrl: './impresion-cobro.component.html',
  styleUrl: './impresion-cobro.component.scss'
})
export class ImpresionCobroComponent extends ImpresionComponent implements OnInit {

    @Input() cobro: Record<string, any>;
    @Input() tipoImpresora: boolean ;
    @Output() eImprimir = new EventEmitter();

    printCharacteristic: BluetoothRemoteGATTCharacteristic ;
    IMPRESION_REIMPRESO = Cobro.ESTADO_IMPRESION_REIMPRESO;

    constructor(
        public bluetoothPrinterService: BluetoothPrinterService,
        public messageService: MessageService,
    ) {
        super();
    }
        
    ngOnInit( ): void {
            
    }

    
    async imprimir() {
        console.log("Normal");
        try {
            const imprimible = document.getElementById("imprimible");
            
            if (imprimible) {
                const domClone = imprimible.cloneNode(true) as HTMLElement;
                let printSection = document.getElementById("printSection");
                
                if (!printSection) {
                    printSection = document.createElement("div");
                    printSection.id = "printSection";
                    document.body.appendChild(printSection);
                }
                
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
                
                // Perform the print operation
                window.print();
                
                // Cleanup: Remove the cloned content from printSection
                printSection.innerHTML = "";

                this.eImprimir.emit(true)
                
                // Optional: Hide the print preview or reset any related state
                // this.showPrint = false;
            }
        } catch (error) {
            console.error("Error occurred while printing:", error);
        }
    }

  
    async imprimirImpresoraTermica() {
        console.log("Termica");
        try {
            const imprimible = document.getElementById('imprimible');
            if (!imprimible) {
                console.error('Elemento imprimible no encontrado.');
                return;
            }
            
            const content = imprimible.innerText.trim().split('\n').filter(line => line.trim()!== '').join('\n');            
            if (!content) {
                console.error('Contenido imprimible vacío.');
                return;
            }
                        
            if (!this.bluetoothPrinterService.isPrinterConnected) {
                this.messageService.add({severity: 'info', summary: 'Impresora no conectada.', detail: 'Seleccione una impresora'});

                await this.bluetoothPrinterService.seleccionarImpresoraBluetooth();
                if ( this.bluetoothPrinterService.ConnectedDevice) {
                    this.printCharacteristic = this.bluetoothPrinterService.ConnectedDevice;
                }
            } else if ( this.bluetoothPrinterService.ConnectedDevice ) {
                this.printCharacteristic =  this.bluetoothPrinterService.ConnectedDevice;
            }
            const encoder = new TextEncoder();
            const resetCommand = this.RESETEAR_IMPRESORA;
            await this.printCharacteristic.writeValue(resetCommand);
            const fontSizeCommand = this.FUENTE_PEQUENA;
            await this.printCharacteristic.writeValue(fontSizeCommand);
            const encodedContent = encoder.encode(content);
            
            const chunkSize = 128;
            for (let i = 0; i < encodedContent.length; i += chunkSize) {
                const chunk = encodedContent.slice(i, i + chunkSize);
                await this.printCharacteristic.writeValue(chunk);
            }
            
            const cortarPapel = this.CORTAR_PAPEL;
            await this.printCharacteristic.writeValue(cortarPapel);            
            const espacio = encoder.encode('\n\n\n')
            await this.printCharacteristic.writeValue(espacio);
            this.eImprimir.emit(true)
        } catch (error) {
            console.error('Error occurred while printing:', error);
        }
    }
}
